module.exports = __webpack_public_path__ + "img/logo.c8e91377.svg";